
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"red"}}),_c('path',{attrs:{"fill":"#00f","d":"M28.357 14H11.643c-.355 0-.643.269-.643.6v10.8c0 .331.288.6.643.6h16.714c.355 0 .643-.269.643-.6V14.6c0-.331-.288-.6-.643-.6zm-1.054 1.2L20 20.443 12.697 15.2h14.606zm.411 9.6H12.286v-8.381l7.322 5.257a.683.683 0 00.784 0l7.322-5.257V24.8z"}})])
          )
        }
      }
    